import { Row, Col, Card } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { Console } from './../services/platform-api';
import WFSettings from '../data/platform/workflow_settings.json';
import { ArchieImg, ArcosImg, ArchieByArc, ArosByArc } from '../assets/images/images';

const CombinationWorkflow = (props) => {
  let this_active = '';
  const wf_first_word = props.recipeName.split(' ')[0];
  const [connectionsData, setconnectionsData] = useState();
  const [workflowData, setworkflowData] = useState();

  // workflow item click, we update the info colum with the chosen connector/trigger
  // this tab value is passed back to the parent through props
  const handlePopupClick = (e, tab) => {
    e.preventDefault();
    props.setActiveWFTab(this_active);
    props.handleShow();
    props.setConnectionTab(tab);
  };
  const handleClick = (e, tab) => {
    e.preventDefault();

    // get recent active wf then remove the class and assign our newly selected with the class
    var elements = document.getElementsByClassName('selected_wf_item');
    if (elements[0]) {
      elements[0].classList.remove('selected_wf_item');
    }
    e.target.closest('.card').classList.add('selected_wf_item');
    Console('tab 1: ', tab, 'log');

    this_active = tab;
    props.setActiveWFTab(tab);
  };

  useEffect(() => {
    setconnectionsData(props.connectionsData);
    setworkflowData(props.workflowData);
    Console('props.connectionsData 1: ', props.connectionsData, 'log');
    Console('props.workflowData: ', props.workflowData, 'log');
  }, [props.connectionsData, props.workflowData]);

  return (
    <Row>
      <Col lg={12}>
        <div className="workflowData">
          {workflowData?.triggers?.length > 0 ? (
            <>
              <h5>Connect Source</h5>
              {workflowData?.triggers.map((trigger) => {
                return (
                  <Card
                    className={`selected_wf_item`}
                    key={'wf-trigger-' + trigger.id}
                    onClick={(e) => handleClick(e, 'wf-trigger-' + trigger.id)}
                  >
                    <div className={`list-unstyled ${'wf-trigger-' + trigger.id === this_active ? 'active' : ''}`}>
                      <img src={`/images/${trigger.icon}`} className="icon-solutions float-left" alt={trigger.name} />
                      {trigger.name}
                    </div>
                  </Card>
                );
              })}
            </>
          ) : null}

          <h5>Add Action</h5>

          {workflowData?.connectors
            .sort((a, b) => (a.order > b.order ? 1 : -1))
            .map((connector, key) => {
              let this_conn_status = '';
              return (
                <Card
                  key={'wf-conn-' + key}
                  className={`list-unstyled ${'wf-conn-' + key === this_active ? 'active' : ''}
                    ${connector?.provider === 'arcanum_ai' ? 'tall_wf_tile' : ''} 
                    ${key === 0 && !workflowData?.triggers?.length ? 'selected_wf_item' : ''}
                    ${'wf-conn-' + key}
                  `}
                  onClick={(e) => handleClick(e, 'wf-conn-' + key)}
                  ref={key === 2 ? props.arc_tab_ref2 : key === 1 ? props.arc_tab_ref1 : null}
                >
                  <div className="align-middle list-unstyled">
                    <img
                      src={`/images/${connector?.icon}`}
                      className="icon-solutions float-left"
                      alt={connector?.name}
                    />

                    {connectionsData?.length > 0 ? (
                      connectionsData.forEach((element) => {
                        if (element?.provider === connector?.provider) {
                          if (element?.authorization_status === 'success') {
                            this_conn_status = (
                              <>
                                <button
                                  className="wf-item-status-connected wf-btn"
                                  title={element.identity}
                                  onClick={(e) => handlePopupClick(e, connector?.provider)}
                                >
                                  connected
                                </button>
                              </>
                            );
                          } else if (element.authorization_status === null) {
                            this_conn_status = (
                              <button
                                className="wf-item-status-notconnected wf-btn"
                                onClick={(e) => handlePopupClick(e, connector?.provider)}
                              >
                                not connected
                              </button>
                            );
                          } else if (element.authorization_status === 'exception') {
                            this_conn_status = (
                              <button
                                className="wf-item-status-notconnected wf-btn"
                                onClick={(e) => handlePopupClick(e, connector?.provider)}
                              >
                                {element.authorization_error} - try again
                              </button>
                            );
                          }
                        }
                      })
                    ) : (
                      <button className=" wf-btn">please wait...</button>
                    )}
                    {connector?.provider === 'arcanum_ai' ? (
                      WFSettings.solution_comboIDs.finance.includes(workflowData.id) ? (
                        <>
                          {wf_first_word} processed by
                          <img src={ArchieByArc} className="ai_assistant" alt="Archie" />
                          <img src={ArchieImg} className="ai_assistant" alt="Archie" />
                        </>
                      ) : WFSettings.solution_comboIDs.operations.includes(workflowData.id) ? (
                        workflowData.id === 168 ? (
                          <>
                            <img src={ArosByArc} className="ai_assistant" alt="Arcos" />
                            <img src={ArcosImg} className="ai_assistant" alt="Arcos" />
                          </>
                        ) : null
                      ) : (
                        wf_first_word + ' processed by ' + connector?.name
                      )
                    ) : (
                      connector?.name
                    )}

                    {this_conn_status}
                  </div>
                </Card>
              );
            })}

          <div className="end">End</div>
        </div>
      </Col>
    </Row>
  );
};

export { CombinationWorkflow };
